import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step8 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("quality");

  const handleOptionClick = (value) => {
    onAnswer("quality", value);
  };

  return (
    <QuizContent className="gridContent step8">
      <QuizTitle className="gridTitle">
        What qualities do you appreciate most in a woman?
      </QuizTitle>
      <QuizOptions className="step8WrapperOp">
        {quizOptions.map((option) => (
          <QuizOption
            className="step8QuizOptions"
            key={option.value}
            value={option.value}
            name="quality"
            onClick={handleOptionClick}
            hasIcon={option.hasIcon}
          >
            {option.hasIcon && (
              <picture>
                <img
                  src={option.image}
                  className="option-icon"
                  alt={option.alt}
                />
              </picture>
            )}
            <div>
              <p>
                <strong>{option.text}</strong>
              </p>
            </div>
          </QuizOption>
        ))}
      </QuizOptions>
    </QuizContent>
  );
};

export default Step8;
